import { Markdown } from "@client/components/Markdown";
import { useT } from "@client/i18n";

/** "I boken": what Young & Freedman say about the ground this panel covers. */
export function BookBox({ children }: { children: string }) {
  const t = useT();
  return (
    <div className="rounded-lg border border-accent-200 bg-accent-50 p-3 text-sm text-ink-800 dark:border-accent-800 dark:bg-accent-950 dark:text-ink-100">
      <p className="mb-1 text-xs font-semibold uppercase tracking-wide text-accent-800 dark:text-accent-200">
        {t("teacher.prep.panel.book")}
      </p>
      <Markdown variant="compact">{children}</Markdown>
    </div>
  );
}
